app.mediator.registerModule(MODULE_NAME__PREVIEW_BAR, function() {

	return {

		//==========================================================xdiv2====
		// Start and stop
		//===================================================================

        onLoaded: function (data) {
            var scope = this;
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                scope.init();
            }
        },

        init: function () {
            var scope = this;

            // Init
            scope.addDomListeners();
		},

        addDomListeners: function() {
	        $("body")
	            .on("click",
	                "#switch-language-button",
	                function () {
	                    $("#jda-preview-language-selector").fadeIn();
	                });

	        $("body")
	            .on("click",
	                "#jda-preview-language-selector .icon",
	                function() {
	                    $("#jda-preview-language-selector").fadeOut();
	                });

	        $("body")
	            .on("click",
	                "#switch-stage-button",
	                function () {
	                    $("#jda-preview-stage-selector").fadeIn();
	                });

	        $("body")
	            .on("click",
	                "#jda-preview-stage-selector .icon",
	                function () {
	                    $("#jda-preview-stage-selector").fadeOut();
	                });

            $("body")
                .on("click",
                    "#jda-preview-close-button",
                    function () {
                        self.parent.close();
                    });
        }
	};
});
